<template>
  <div>

    <div v-if="files.length>1">
      <el-container>
        <el-aside style="width: calc(100% - 585px)">
          <div id="dplayer"></div>
<!--          <div>-->
<!--            <d-player :options="options"-->
<!--                      ref="player">-->
<!--            </d-player>-->
<!--          </div>-->
        </el-aside>

        <el-main>

          <div class='sc-list' >

            <div class="sc-item" v-for="(item,index) in files" :key="index">

              <el-tooltip class="item" effect="dark" :content="item.file_name" placement="top">

                <div v-if="series_num - 1 === index">
                  <el-button type="success" @click="goVideo(index+1)">{{index+1}}</el-button>
                </div>

                <div v-else>
                  <el-button @click="goVideo(index+1)">
                    {{index+1}}
                  </el-button>
                </div>

              </el-tooltip>

            </div>

          </div>

        </el-main>
      </el-container>
    </div>

  </div>
</template>

<script>

import 'flv.js'
import DPlayer from 'dplayer'

// import VueDPlayer from 'vue-dplayer'
//
// import 'vue-dplayer/dist/vue-dplayer.css'

// import Common from '../../../js/Common'
export default {
  name: 'VideoPlayer',
  components: {
    // 'd-player': VueDPlayer
  },
  props: {
    data: Object
  },
  data () {
    return {
      type: '',
      content_id: '',
      category: '',
      files: '',
      series_num: '',
      videoUrl: 'http://192.168.1.4:8090/live.flv',
      options: {
        video: {
          url: 'http://192.168.1.4:8090/live.flv',
          pic: 'http://static.smartisanos.cn/pr/img/video/video_03_cc87ce5bdb.jpg',
          type: 'flv'
        },
        autoplay: false,
        contextmenu: [
          {
            text: 'GitHub',
            link: 'https://github.com/MoePlayer/vue-dplayer'
          }
        ]
      },
      player: null
    }
  },
  created () {
    // this.player = this.$refs.player

    console.log(this.$refs)
    console.log(this.player)
    console.log(this.player.player)
    console.log(this.player.player.dp)
  },
  mounted () {

  },
  methods: {

    init () {
      console.log(this.data)

      this.type = this.data.type
      this.content_id = this.data.content_id
      this.category = this.data.category
      this.files = this.data.files
      this.series_num = this.data.series_num

      if (this.series_num > 0 && this.files.length >= this.series_num) {
        // var fileData = this.files[this.series_num - 1]

        // this.videoUrl = Common.fileUrl + this.type + '/' + fileData.file_path + '/' + fileData.file_name

        // console.log(this.videoUrl)
      }

      // this.playerOptions.poster = Common.Getshipinhaibao(this.$route.query.videoid)

      // this.playerOptions.sources[0].src = this.data.videoUrl

      this.dp = new DPlayer({
        container: document.getElementById('dplayer'),
        video: {
          url: 'http://192.168.1.4:8090/live.flv', // 视频路径
          type: 'flv'
          // pic: './2.png'
        },
        autoplay: false, // 自动播放
        theme: '#b7daff', // 主题色
        loop: true, // 循环播放
        lang: 'zh-cn', // 语言
        // screenshot: true,  //截图
        hotkey: true, // 热键：→快进等
        preload: 'auto', // 预加载
        // logo: require('./1.png'), // 左上方log
        volume: 0.7, // 默认音量
        mutex: true, // 互斥
        contextmenu: [
          {
            text: 'custom1'
          },
          {
            text: 'custom2'
          }
        ],
        // danmaku:true,
        highlight: []
      })
      // 执行API
      this.dp.on('play', () => { // 开始播放
      })
      this.dp.on('timeupdate', () => { // 记录当前播放时间
        // console.log(this.dp.video.currentTime)
      })
    },

    goVideo (index) {
      console.log(this.player)

      switch (this.type) {
        case 'movie':
          this.$router.push({path: '/movie/movie_info', name: 'MovieInfo', query: {movie_id: this.content_id}})
          break
        case 'tvseries':
          this.$router.push({path: '/tvseries/tvseries_info', name: 'TVSeriesInfo', query: {tvseries_id: this.content_id}})
          break
        case 'comic':
          this.$router.push({path: '/comic/comic_info', name: 'ComicInfo', query: {comic_id: this.content_id, series_num: index}})
          break
        default:
          break
      }
    },

    getVideoPlayerWidth () {
      var width
      if (this.files.length > 1) {
        width = 'width:calc(100% - 585px)'
      } else {
        width = 'width:100%'
      }
      return width
    }
  }
}
</script>

<style scoped>
.sc-item{
  text-align: center;
  /*float: left;*/

  margin-top:20px;
  margin-bottom:20px;
  /*margin: 20px auto;*/

}
.sc-list{
  flex-wrap: wrap;
  /*margin-left:@lrwith;*/
  /*margin-right:@lrwith;*/
  display: flex;
  justify-content: space-around;
  /* !主轴水平时!决定了item在交叉轴上的对齐方式，可能的值有flex-start|flex-end|center|baseline|stretch */
  /*align-items: center;*/
}
</style>



// WEBPACK FOOTER //
// src/components/pc/widgets/VideoPlayer.vue